export default "__VITE_ASSET__Bj2b1n67__ 100w";